import { render, staticRenderFns } from "./auth.vue?vue&type=template&id=1e35a2fa"
import script from "./auth.vue?vue&type=script&lang=ts"
export * from "./auth.vue?vue&type=script&lang=ts"
import style0 from "./auth.vue?vue&type=style&index=0&id=1e35a2fa&prod&lang=stylus"
import style1 from "./auth.vue?vue&type=style&index=1&id=1e35a2fa&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports